export const validTemperature = (namespace, data, translate) => {
  let error = {};

  switch (namespace) {
    case "name":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("Category Name"),
        });
      }else if(data.length > 256){
        error[namespace] = translate("COMMON:MAX_LENGTH", {
          field: translate("Category Name"),
        });
      } else {
        error[namespace] = null;
      }
      break;
      case "description":
        if (!data) {
          error[namespace] = translate("COMMON:REQUIRE", {
            field: translate("Description"),
          });
        }else if(data.length > 256){
          error[namespace] = translate("COMMON:MAX_LENGTH", {
            field: translate("Description"),
          });
        } else {
          error[namespace] = null;
        }
        break;
        case "uom_id":
        if (!data) {
          error[namespace] = translate("COMMON:REQUIRE", {
            field: translate("Temperature Code"),
          });
        } else {
          error[namespace] = null;
        }
        break;
    default:
      break;
  }
  return error;
}
